import React, { useEffect, useState } from "react";
import { Grid, Typography } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";
import { globalTheme } from "style/globalTheme";
import styled from "styled-components";
import { brandPalette } from "brand/theme/brandTheme";
import { employerSearchOptInSchema } from "app/components/mvp/formWidget/model/employerSearchOptInJson";
import { employerSearchOptInUiSchema } from "app/components/uiSchema/employerSearchOptInUiSchema";
import { EmployerSearchOptInPayload } from "app/services/payloadSubmit/employerSearchOptInPayload";
import { config } from "utilities/config";
import { post } from "app/services/api";
import FormWidget from "app/components/mvp/formWidget";

const Heading = styled.div`
  height: 15rem;
  padding: 1rem 1.2rem;
  background-image: linear-gradient(
      to right bottom,
      ${brandPalette["Complementary"][200]},
      ${brandPalette["Analogous-1"][600]}
    ),
    url(brand/slide4.jpeg);
  clip-path: polygon(0 0, 100% 0, 100% 80%, 0% 100%);
  display: flex;
  align-items: flex-end;

  h2 {
    font-size: 2rem;
    letter-spacing: 0.07rem;
    text-transform: uppercase;
    font-weight: 700;
    color: white;
    background-image: linear-gradient(
      to right,
      rgba(60, 60, 60, 0.5),
      rgba(0, 28, 48, 0.5)
    );
    padding: 0.5rem 1.5rem;
    border-radius: 8px;
    margin: 0 0 1.5rem 0;
  }
`;

const Content = styled.section`
  padding: 2rem 1rem;
  min-height: 30rem;
  background-color: #fafafa;
`;

const OptInToEmployerSearch = () => {
  const contactid = useSelector((state) => state.contactid);
  const [formData, setFormData] = useState({});
  const dispatch = useDispatch();

  const formOptions = {
    widgetType: "updateContact",
    formSchema: employerSearchOptInSchema,
    uiSchema: employerSearchOptInUiSchema,
    formData: formData,
    apiURL: config.teleportal.submitForm.Update,
    payloadSchema: {},
    entityType: "contacts",
    formUischema: "",
    button1Label: "Save",
    button2Label: "Go Back",
    payloadSubmit: EmployerSearchOptInPayload,
    contactId: contactid,
    goBackPage: "/",
    button2GoBack: true,
    historyUrl: "",
  };

  const [formOptionsState, setFormOptionsState] = useState(formOptions);

  useEffect(() => {
    if (contactid && contactid.length > 0) {
      getContactDetails();
    }
  }, [contactid]);

  const updateFormData = (entityType, formData) => {
    formOptions.formData = formData;
    formOptions.initialFormData = formData;
    setFormOptionsState(formOptions);
    setFormData(formData);
  };

  const getContactDetails = () => {
    const api = config.teleportal.submitForm.getId;
    const payloads = {
      properties: [
        "contactid",
        "ctpt_connectsearch",
        "ctpt_discipline",
        "ctpt_qualifications",
        "ctpt_professionalregistration",
        "ctpt_employmentstatus",
        "ctpt_willingtorelocate",
        "ctpt_employmenttype",
        "_ctpt_branchid_value",
      ],
      formattedFields: ["_ctpt_branchid_value"],
      recordType: "contacts",
      id: contactid,
    };

    post(api, payloads)
      .then((res) => {
        const formDataObj = {};
        res.data.data.forEach((x) => {
          // For lookup fields (formatted fields), use id if available, otherwise use value
          if (x.name === "_ctpt_branchid_value" && x.id) {
            formDataObj[x.name] = x.id;
          } else {
            formDataObj[x.name] = x.value;
          }
        });
        updateFormData({}, formDataObj);
      })
      .catch((error) => {
        console.log("Error fetching contact details:", error);
        dispatch({
          type: "SET_STATUS",
          payload: {
            message: "Failed to load contact details",
            code: "",
            display: "show",
            severity: "error",
          },
        });
      });
  };

  const getResponse = (res) => {
    if (res.data.id) {
      dispatch({
        type: "SET_STATUS",
        payload: {
          message: "Record updated successfully",
          code: "",
          display: "show",
          severity: "success",
        },
      });
      // Refresh contact data after successful update
      if (contactid && contactid.length > 0) {
        getContactDetails();
      }
    } else {
      dispatch({
        type: "SET_STATUS",
        payload: {
          message: "Failed to update record",
          code: "",
          display: "show",
          severity: "error",
        },
      });
    }
  };

  return (
    <ThemeProvider theme={globalTheme}>
      <Heading>
        <h2>Employment - SAICE Connect</h2>
      </Heading>
      <Content>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <Grid container spacing={0} justify="center">
              <Grid item xs={12} md={9}>
                <FormWidget
                  options={formOptionsState}
                  updateFormData={updateFormData}
                  successResponse={getResponse}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Content>
    </ThemeProvider>
  );
};

export default OptInToEmployerSearch;

